export function hexToRgb(hexObj) {
  const hex = hexObj.toString().replace(/^#/, '');
  const rHex = hex.substring(0, 2);
  const gHex = hex.substring(2, 4);
  const bHex = hex.substring(4, 6);
  const r = parseInt(rHex, 16);
  const g = parseInt(gHex, 16);
  const b = parseInt(bHex, 16);
  return `rgb(${r}, ${g}, ${b})`;
}

export function rgbToHex(rgb) {
  const [r, g, b] = rgb.match(/\d+/g).map(Number);
  const rHex = r.toString(16).padStart(2, '0');
  const gHex = g.toString(16).padStart(2, '0');
  const bHex = b.toString(16).padStart(2, '0');
  return `#${rHex}${gHex}${bHex}`;
}
